import {Create, SimpleForm, TextInput, FileInput, FileField} from 'react-admin';

export const FirmwareCreate = props => (
    <Create>
        <SimpleForm>
            <TextInput source="description" />
            <FileInput multiple={false} source="files" label="Firmware Image File">
                <FileField source="src" title="title" />
            </FileInput>
        </SimpleForm>
    </Create>
);
